<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] font-bold text-[#3a3d44] text-center leading-[1.3]">Восстановление пароля</h2>
    </div>
    <p class="text-sm text-[rgba(58,61,68,0.6)] text-center">Укажите вашу почту</p>
    <form class="flex flex-col items-center gap-[12px] w-full" @submit.prevent="handleSubmit">
      <UINewInput
        v-model="emailValue"
        placeholder="Ваша почта"
        type="email"
        class="!w-[368px] max-md:!w-full"
        input-classes="!rounded-[12px] !border-[#d9e5ff] w-full"
        :validation-rules="[{ type: 'required', message: 'Введите email' }]"
        @update:validation-error="emailError = $event"
      />
      <p v-if="serverError" class="text-[#f8465b] text-sm w-[368px] max-md:w-full">{{ serverError }}</p>
      <button
        type="submit"
        class="bg-primary rounded-[12px] py-3 w-[368px] max-md:w-full text-white font-bold text-base disabled:opacity-50"
        :disabled="loading || !!emailError || !emailValue"
      >
        <span v-if="loading" class="loader-inline mr-2" />
        Сбросить пароль
      </button>
    </form>
    <div class="flex items-center justify-center pt-[12px]">
      <span class="text-primary text-sm cursor-pointer" @click="$emit('setMode', LoginMode.EMAIL_PASSWORD)">
        Назад
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';
import AuthService from '~/services/AuthService';

const emit = defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
  (e: 'setEmail', email: string): void;
}>();

const props = defineProps<{
  email: string;
}>();

const emailValue = ref(props.email);
const emailError = ref('');
const serverError = ref('');
const loading = ref(false);

const handleSubmit = async () => {
  if (!emailValue.value || emailError.value) return;
  loading.value = true;
  serverError.value = '';
  try {
    await AuthService.passwordRequest(emailValue.value);
    emit('setEmail', emailValue.value);
    emit('setMode', LoginMode.RECOVERY_SENT);
  } catch (error: any) {
    serverError.value = 'Почта не найдена!';
  } finally {
    loading.value = false;
  }
};
</script>
